import React from 'react';
import Header from "../../components/header/header.component";
import Footer from "../../components/footer/footer.component";
import './tasks-available.styles.scss';
import AvailableTasks from '../../components/available-tasks/available-tasks.component';


const TasksAvailable = (props) => {
  return (
    <div className='parent'>
      <Header /> 
      <div className='task-list'>
        <div className='task-list-title'>
          <h3>Servicios Disponibles</h3>
        </div>

        <AvailableTasks {...props} />

      </div>

      <Footer />
    </div>
  )
};

export default TasksAvailable;
